var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrown = function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m22.968 10.177-2.076 9.171a.844.844 0 0 1-.843.667H3.883a.84.84 0 0 1-.843-.667l-2.008-9.17A.844.844 0 0 1 2.23 9.24l4.927 2.387 4.083-7.222a.844.844 0 0 1 1.468 0l4.084 7.23 4.96-2.404a.844.844 0 0 1 1.216.945"
  })));
};
export default SvgIconCrown;